import { catchError, map, of, type Observable } from 'rxjs';

import { request } from 'app/utils/request';
import { getApiUrl, getTangerineHeaders } from 'app/utils/api';
import { assertNever } from 'app/utils/types';

import type { GlobalState, GlobalWSMessage } from './types';

const createOutrightsSeriesOpenRemindersCountRequest = (): Observable<number> =>
  request<number>({
    url: getApiUrl(`/series/open_reminders_count`),
    headers: getTangerineHeaders()
  }).pipe(
    map(response => response.data!),
    catchError(() => of(0))
  );

const creatGlobalDataRequest = (userType: UserType): Observable<GlobalState> => {
  const outrightsSeriesOpenRemindersCountRequest =
    userType === 'pandascore' ? createOutrightsSeriesOpenRemindersCountRequest() : of(0);
  return outrightsSeriesOpenRemindersCountRequest.pipe(
    map(value => ({ outrightsSeriesOpenRemindersCount: value }))
  );
};

const handeGlobalMessage = (
  currentData: GlobalState,
  message: GlobalWSMessage
): Observable<GlobalState> => {
  switch (message.type) {
    case 'init_ressource': {
      return of(currentData);
    }
    case 'serie_open_reminders_count': {
      return of({
        ...currentData,
        outrightsSeriesOpenRemindersCount: message.model
      });
    }
    default:
      return assertNever(message);
  }
};

export { creatGlobalDataRequest, handeGlobalMessage };
